import { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import { changeAccessLimitedModalVisibilityStatus } from "../../store/domain-access-modal/actions";
import { AppState } from "../../store/root-reducer";
import { KModal } from "../ui-kit/k-modal/k-modal";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";

interface IAccessLimitedModalProps {
  showModal?: boolean;
  showAccessLimitedModal?: boolean;
  changeAccessLimitedModalVisibilityStatus: (status?: boolean) => void;
  onClose?: () => void;
  onContactUsClicked?: () => void;
}
interface IAccessLimitedModalState {}

class AccessLimitedModal extends PureComponent<IAccessLimitedModalProps, IAccessLimitedModalState> {
  constructor(props) {
    super(props);
  }

  render(): ReactNode {
    const { showModal, showAccessLimitedModal, onClose, changeAccessLimitedModalVisibilityStatus, onContactUsClicked } =
      this.props;
    return (
      <KModal
        className="access-limited-modal"
        showModal={showModal || showAccessLimitedModal}
        header="ACCESS LIMITED"
        width={332}
        closeModal={() => {
          changeAccessLimitedModalVisibilityStatus();
          if (onClose) onClose();
        }}
        centered
      >
        <div className="access-limited-modal__content">
          <KuikaModalIconWrapper iconName="alert-triangle" intent="warning" />
          <div className="access-limited-modal__title">Unable to access account</div>
          <div className="access-limited-modal__description">
            Access may be limited due to not being used for a long period. If you think your account is valid and
            active, contact us via the support channel.
          </div>
          <KuikaButton
            className="access-limited-modal__contact-btn"
            type="primary"
            onClick={() => {
              changeAccessLimitedModalVisibilityStatus();
              if (onContactUsClicked) onContactUsClicked();
            }}
          >
            CONTACT US
          </KuikaButton>
        </div>
      </KModal>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  showAccessLimitedModal: state.domainAccessModal.showAccessLimitedModal
});
const mapDispatchToProps = (dispatch) => ({
  changeAccessLimitedModalVisibilityStatus: (status: boolean = false) =>
    dispatch(changeAccessLimitedModalVisibilityStatus(status))
});

const accessLimitedModal = connect(mapStateToProps, mapDispatchToProps)(AccessLimitedModal);
export { accessLimitedModal as AccessLimitedModal };
